import { apiAxiosAuth } from 'services/api';
import { CollectionProps } from 'types/CollectionProps';

export async function getCollection(
	wordToSearchDebounced: string,
	setOptions: React.Dispatch<React.SetStateAction<CollectionProps[]>>,
	setIsOpen: React.Dispatch<React.SetStateAction<boolean>>,
	handleNotify: any
) {
	await apiAxiosAuth
		.get(
			`bridge/vtex/api/catalog_system/pvt/collection/search/${wordToSearchDebounced}`
		)
		.then((resp) => {
			if (resp.data.items) {
				setOptions(resp.data.items);

				if (resp.data.items.length > 0) {
					setIsOpen(true);
				}
			}
		})
		.catch((error) => {
			handleNotify(error?.message || 'Erro ao bucas as coleções', 'error');
		});

	return '';
}
